import EtablissementVille from '@/generated/controls/etablissement/EtablissementVille.vue';
import { defineComponent } from "vue";

export default defineComponent({ components: {},
    extends: EtablissementVille
})
